(ns runtime.core)

(goog-define DEBUG false)

(defonce env' (atom {}))

(defn set-env! [x]
  (reset! env' x))

(defn env []
  (deref env'))

(defn ie11? []
  (if (.-isIE11 js/window)
    (.isIE11 js/window)
    false))
